export default [
  {
    name: 'welcome',
    path: '/welcome',
    component: require('@/views/WelcomeView').default
  },
  {
    name: 'journey',
    path: '/journey',
    component: require('@/views/JourneyView').default
  },
  {
    name: 'chef',
    path: '/chef',
    component: require('@/views/ChefView').default
  },
  {
    name: 'selection',
    path: '/selection',
    component: require('@/views/SelectionView').default,
    options: {
      transition: 'f7-flip'
    }
  },
  {
    name: 'success',
    path: '/success',
    component: require('@/views/SuccessView').default
  }
]
